import { SubNavContainer } from '@/components/sub-nav-container';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/sitemap/')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Sitemap - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  const sitemapItems = [
    {
      title: t('sitemap.home.title'),
      description: t('sitemap.home.description'),
      to: '/',
    },
    {
      title: t('sitemap.about.title'),
      description: t('sitemap.about.description'),
      to: '/about-us',
    },
    {
      title: t('sitemap.services.title'),
      description: t('sitemap.services.description'),
      to: '/services',
    },
    {
      title: t('sitemap.catalogue.title'),
      description: t('sitemap.catalogue.description'),
      to: '/services/services-catalogue',
    },
    {
      title: t('sitemap.faq.title'),
      description: t('sitemap.faq.description'),
      to: '/faq',
    },
    {
      title: t('sitemap.feedback.title'),
      description: t('sitemap.feedback.description'),
      to: '/feedback-hub',
    },
    {
      title: t('sitemap.contact.title'),
      description: t('sitemap.contact.description'),
      to: '/contact-us',
    },
    {
      title: t('sitemap.accessibility.title'),
      description: t('sitemap.accessibility.description'),
      to: '/accessibility',
    },
  ];

  return (
    <>
      <SubNavContainer showOneStepBreadcrumbs>
        <div className="max-w-container-960">
          <h1 className="text-3xl font-bold mb-5 text-foreground">{t('sitemap.title')}</h1>
          <p className="text-xl font-normal text-foreground">{t('sitemap.subtitle')}</p>
        </div>
      </SubNavContainer>
      <div className="max-w-container-960 mx-auto py-8 px-4 lg:px-0 space-y-4">
        {sitemapItems.map((item, index) => (
          <div key={index} className="border-b border-gray-200 py-5">
            <Link to={item.to} className="text-lg font-semibold text-link underline underline-offset-8">
              {item.title}
            </Link>
            <p className="text-base font-normal text-foreground">{item.description}</p>
          </div>
        ))}
      </div>
    </>
  );
}
